export default __webpack_public_path__ + "static/media/evan.png.webp";